/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';
import { useParams, useLocation, Link as RouterLink } from 'react-router-dom';
import { Button, Container, FormControlLabel, Switch } from '@material-ui/core';
import CreateClientForm from 'src/components/_dashboard/client/CreateClientForm';
import ClientList from 'src/components/_dashboard/client/ClientList';

import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import backFill from '@iconify/icons-eva/arrow-back-fill';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getUserList } from '../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

// ----------------------------------------------------------------------

export default function OmniChannel() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  // const { name } = useParams();
  // const { userList } = useSelector((state) => state.user);
  const isEdit = pathname.includes('edit');
  // const currentUser = userList.find((user) => paramCase(user.name) === name);

  return (
    <Page title="Omni Channel | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Omni Channel"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Omni Channel', href: PATH_DASHBOARD.general.omni_channel },
            { name: 'Omni Channel View' }
          ]}
        />
      </Container>
    </Page>
  );
}
